module.exports = __webpack_public_path__ + "static/media/fluent_building-bank-28-regular (1).37ecd46e.svg";